import { GenericBaseParameter } from "../../models/base-parameter";
import { IPropertyParameterModel, IPropertyListingModel } from "../../models/property";
import { PagingListResponse, BaseListing } from "../listing-base-model";

export class MatchingPropertyRequest extends GenericBaseParameter<IPropertyParameterModel> {
    DemandId: number;
    IsMapping: boolean = true;
    IsSearchMatching?: boolean = true;
    constructor(pageIndex?: number, pageSize?: number, orderBy?: string, fields?: string, condition?: IPropertyParameterModel) {
        super(pageIndex, pageSize, orderBy, fields, condition);
    }
}

export class MatchingPropertyResponse extends PagingListResponse<IPropertyListingModel> {
    Condition: IPropertyParameterModel;
    DemandReference: string;
    IsSearchMatching?: boolean = true;
    constructor(response?: BaseListing) {
        super(response);

        this.Condition = response.condition;
        delete response.condition;
    }
}